import { POSTRegisterReqBody } from '@myme/api/src/kratos';
import { kratosIntegration } from '@myme/utils/src/requests/kratosIntegration';
import { SelfServiceRegistrationFlow } from '@ory/kratos-client';
import { KratosInitFlow } from '../types';

export const handleRegisterWeb = async (registerFlow: KratosInitFlow, data: POSTRegisterReqBody) => {
  const { password, passwordConfirm, email, ...traits } = data;

  const overrideReqBody = {
    csrf_token: registerFlow.csfrToken,
    method: 'password',
    password,
    traits: {
      email: email.toLowerCase(),
      ...traits
    }
  };

  return kratosIntegration.request.submitSelfServiceRegistrationFlow(registerFlow.flowId, overrideReqBody);
};

export const handleRegisterMobile = async (registerFlow: SelfServiceRegistrationFlow, data: POSTRegisterReqBody) => {
  const { password, passwordConfirm, ...traits } = data;

  const overrideReqBody = {
    method: 'password',
    password,
    traits
  };

  return kratosIntegration.request.submitSelfServiceRegistrationFlow(registerFlow.id, overrideReqBody);
};
